import { render, staticRenderFns } from "./OrganizationsUpdate.vue?vue&type=template&id=9872b39a"
import script from "./OrganizationsUpdate.vue?vue&type=script&lang=js"
export * from "./OrganizationsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports